/* src/app/common/components/lumi/lumi.component.scss */
.lumi-container {
  z-index: 10000000;
  width: 100%;
  height: 6.25rem;
  border-left: 0.25rem solid transparent;
  border-top: 0.0625rem solid transparent;
  border-right: none;
  border-bottom: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  position: relative;
  background: transparent;
  padding: 0;
  transition: all 300ms cubic-bezier(0, 0.6, 0.4, 1);
}
.lumi-container ::ng-deep svg-icon svg {
  height: 1.5rem !important;
  width: 1.5rem !important;
}
.lumi-container ::ng-deep svg-icon {
  color: #1E31BF !important;
}
.lumi-container ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #1E31BF !important;
  stroke: #1E31BF !important;
}
.lumi-container ::ng-deep svg-icon svg g {
  color: #1E31BF !important;
}
.lumi-container ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #1E31BF !important;
}
.lumi-container:hover {
  background-color: #F5F7FA;
  cursor: pointer;
}
.lumi {
  z-index: 10000000;
}
.lumi.addin {
  max-width: 90vw;
}
@starting-style {
  .lumi.addin {
    opacity: 0;
    transform: translateX(12rem);
  }
}
.lumi.addin:not(.lumi-panel-open) {
  opacity: 0;
  transform: translateX(12rem);
}
.lumi {
  width: 22rem;
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 0;
  max-height: calc(90vh - 2rem);
  border: 0.0625rem solid #EBEBEB;
  border-radius: 0.5rem;
  background-color: #FFFFFF;
  font-family: "PoppinsMedium";
  font-size: 1rem;
  line-height: 125%;
  color: #757575;
  margin: auto;
  inset: auto auto 1.25rem 7.75rem;
  box-shadow: 0rem 0.1875rem 0.1875rem rgba(0, 0, 0, 0.13), 0rem 0.3125rem 0.625rem rgba(0, 0, 0, 0.09);
  position: fixed;
  overflow: visible;
  transition:
    width 350ms cubic-bezier(0.4, 0, 0.2, 1),
    height 350ms cubic-bezier(0.4, 0, 0.2, 1),
    max-height 350ms cubic-bezier(0.4, 0, 0.2, 1),
    inset 350ms cubic-bezier(0.4, 0, 0.2, 1),
    opacity 300ms ease,
    transform 300ms ease,
    display 300ms allow-discrete,
    overlay 300ms allow-discrete;
  opacity: 1;
  transform: translateX(0);
}
.lumi.expanded {
  width: 42rem;
}
@starting-style {
  .lumi {
    opacity: 0;
    transform: translateX(-7rem);
  }
}
.lumi:not(.lumi-panel-open) {
  opacity: 0;
  transform: translateX(-7rem);
  pointer-events: none;
}
.lumi::after {
  content: "";
  position: absolute;
  bottom: 9.65rem;
  left: -0.75rem;
  width: 0.75rem;
  height: 1.25rem;
  background-color: #FFFFFF;
  clip-path: polygon(100% 0, 100% 100%, 0 50%);
  filter: drop-shadow(0rem 0.1875rem 0.1875rem rgba(0, 0, 0, 0.13)) drop-shadow(0rem 0.3125rem 0.625rem rgba(0, 0, 0, 0.09));
}
.lumi::before {
  content: "";
  position: absolute;
  bottom: 9.6rem;
  left: -0.85rem;
  width: 0.85rem;
  height: 1.35rem;
  background-color: #EBEBEB;
  clip-path: polygon(100% 0, 100% 100%, 0 50%);
  z-index: -1;
  filter: drop-shadow(0rem 0.1875rem 0.1875rem rgba(0, 0, 0, 0.13)) drop-shadow(0rem 0.3125rem 0.625rem rgba(0, 0, 0, 0.09));
}
.lumi .lumi-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: visible;
}
.lumi .lumi-body .lumi-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
  padding: 1.5rem;
  padding-bottom: 1rem;
  flex-shrink: 0;
}
.lumi .lumi-body .lumi-header .lumi-logo {
  width: 5rem;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-dismiss {
  text-align: right;
  background: none;
  border: none;
  padding: 0;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-dismiss ::ng-deep svg-icon svg {
  height: 1.25rem !important;
  width: 1.25rem !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-dismiss ::ng-deep svg-icon {
  color: #15141E !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-dismiss ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #15141E !important;
  stroke: #15141E !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-dismiss ::ng-deep svg-icon svg g {
  color: #15141E !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-dismiss ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #15141E !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-dismiss {
  transition: all 300ms ease-in-out;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-dismiss:hover {
  cursor: pointer;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-dismiss:hover ::ng-deep svg-icon {
  color: #757575 !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-dismiss:hover ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #757575 !important;
  stroke: #757575 !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-dismiss:hover ::ng-deep svg-icon svg g {
  color: #757575 !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-dismiss:hover ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #757575 !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-expand {
  text-align: right;
  margin-top: 1.5px;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-expand ::ng-deep .lumi-expand-icon ::ng-deep svg-icon svg {
  height: 1.05rem !important;
  width: 1.05rem !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-expand ::ng-deep .lumi-expand-icon ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon):not([stroke=currentColor]) {
  stroke: transparent !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-expand ::ng-deep .lumi-expand-icon ::ng-deep svg-icon svg g :is(circle, line):not([stroke=currentColor]) {
  stroke: transparent !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-expand ::ng-deep .lumi-expand-icon ::ng-deep svg-icon {
  color: #1E31BF !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-expand ::ng-deep .lumi-expand-icon ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #1E31BF !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-expand ::ng-deep .lumi-expand-icon ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #1E31BF !important;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-expand ::ng-deep .lumi-expand-icon {
  transition: all 300ms ease-in-out;
  opacity: 1;
}
.lumi .lumi-body .lumi-header .lumi-expand-dismiss .lumi-expand ::ng-deep .lumi-expand-icon:hover {
  cursor: pointer;
  opacity: 1 !important;
}
.lumi .lumi-body .lumi-content {
  padding: 1.5rem;
  padding-top: 0;
  min-height: 0;
  max-height: calc(90vh - 12rem);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: height 350ms cubic-bezier(0.4, 0, 0.2, 1);
}
.lumi .lumi-body .lumi-content.history,
.lumi .lumi-body .lumi-content.info,
.lumi .lumi-body .lumi-content.project_help,
.lumi .lumi-body .lumi-content.support_messages,
.lumi .lumi-body .lumi-content.polarix_help {
  padding: 0rem;
}
.lumi .lumi-body .lumi-content .lumi-mode-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.lumi .lumi-body .lumi-content .lumi-mode-panel.help_request .return-title {
  padding-left: 0 !important;
  margin-left: -0.5rem;
}
.lumi .lumi-body .lumi-content .lumi-mode-panel.home {
  overflow-y: auto;
}
.lumi .lumi-body .lumi-content .lumi-mode-panel.info,
.lumi .lumi-body .lumi-content .lumi-mode-panel.history,
.lumi .lumi-body .lumi-content .lumi-mode-panel.support_messages {
  overflow-y: auto;
}
.lumi .lumi-body .lumi-content .lumi-mode-panel.info .return-title,
.lumi .lumi-body .lumi-content .lumi-mode-panel.history .return-title,
.lumi .lumi-body .lumi-content .lumi-mode-panel.support_messages .return-title {
  padding-left: 1rem;
  flex-shrink: 0;
}
.lumi .lumi-body .lumi-content .lumi-mode-panel.info,
.lumi .lumi-body .lumi-content .lumi-mode-panel.history,
.lumi .lumi-body .lumi-content .lumi-mode-panel.support_messages {
  min-height: 37rem;
}
.lumi .lumi-body .lumi-content .lumi-mode-panel.project_help,
.lumi .lumi-body .lumi-content .lumi-mode-panel.polarix_help {
  min-height: 32rem;
}
.lumi .lumi-body .lumi-content .lumi-mode-panel.help_request {
  overflow-y: auto;
}
.lumi .lumi-body .lumi-content .return-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  gap: 0.15rem;
}
.lumi .lumi-body .lumi-content .return-title .return-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
}
.lumi .lumi-body .lumi-content .return-title .return-icon ::ng-deep svg-icon svg {
  height: 1.5rem !important;
  width: 1.5rem !important;
}
.lumi .lumi-body .lumi-content .return-title .return-icon ::ng-deep app-centrui-icon {
  display: flex;
  align-items: center;
}
.lumi .lumi-body .lumi-content .return-title .return-icon ::ng-deep svg-icon {
  display: flex;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
}
.lumi .lumi-body .lumi-content .return-title .return-icon ::ng-deep svg-icon svg {
  width: 1.5rem;
  height: 1.5rem;
}
.lumi .lumi-body .lumi-content .return-title .return-icon ::ng-deep svg-icon svg path {
  fill: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .return-title span {
  font-family: "PoppinsSemi Bold";
  font-size: 1rem;
  line-height: 1.25rem;
  color: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .help-form-submitted {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.lumi .lumi-body .lumi-content .help-form-submitted .help-form-submitted-title {
  text-align: center;
  font-family: "Verveine";
  font-size: 1.35rem;
  line-height: 1.75rem;
  color: #1E31BF;
  margin-bottom: 1rem;
}
.lumi .lumi-body .lumi-content .help-form-submitted .help-form-submitted-subtitle {
  text-align: center;
  font-family: "PoppinsRegular";
  font-size: 0.75rem;
  color: #757575;
}
.lumi .lumi-body .lumi-content p.ai-assistant {
  font-family: "PoppinsRegular";
  font-size: 0.75rem;
  line-height: 1rem;
  color: #757575;
  text-align: left;
  margin-left: 0;
  margin-bottom: 1rem;
  margin-left: 2.675rem;
}
.lumi .lumi-body .lumi-content .lumi-info-content {
  width: calc(100% - 3rem);
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.lumi .lumi-body .lumi-content .lumi-info-content::-webkit-scrollbar {
  width: 0.25rem;
}
.lumi .lumi-body .lumi-content .lumi-info-content::-webkit-scrollbar-thumb {
  background: #1E31BF;
  border-radius: 0.25rem;
}
.lumi .lumi-body .lumi-content .lumi-info-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 0.25rem;
}
.lumi .lumi-body .lumi-content .lumi-info-content .about-lumi-button-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  padding-bottom: 1.5rem;
}
.lumi .lumi-body .lumi-content .lumi-info-content .about-lumi-button-wrapper .about-lumi-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background-color: rgba(230, 234, 255, 0.4);
  border: 1px solid #E6EAFF;
  padding: 0.5rem;
  border-radius: 0.25rem;
}
.lumi .lumi-body .lumi-content .lumi-info-content .about-lumi-button-wrapper .about-lumi-button:hover {
  cursor: pointer;
}
.lumi .lumi-body .lumi-content .lumi-info-content .about-lumi-button-wrapper .about-lumi-button img {
  width: 1.15rem;
}
.lumi .lumi-body .lumi-content .lumi-info-content .about-lumi-button-wrapper .about-lumi-button {
  font-family: "PoppinsSemi Bold";
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #1E31BF;
}
.lumi .lumi-body .lumi-content .lumi-info-content p {
  font-family: "PoppinsRegular";
  font-size: 0.75rem;
  line-height: 1.25rem;
  color: #757575;
}
.lumi .lumi-body .lumi-content .lumi-info-content p.knowledge-base {
  font-family: "Verveine";
  font-size: 1rem;
  line-height: 1.25rem;
  color: #15141E;
  text-align: center;
  margin-top: 1rem;
}
.lumi .lumi-body .lumi-content .history-list {
  width: calc(100% - 3rem);
  margin-top: 1.5rem;
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.lumi .lumi-body .lumi-content .history-list .lumi-list-loading {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 12rem;
}
.lumi .lumi-body .lumi-content .history-list .no-conversations-message {
  text-align: center;
  font-family: "PoppinsRegular";
  font-size: 0.75rem;
}
.lumi .lumi-body .lumi-content .history-list .history-load-more {
  display: flex;
  justify-content: center;
  padding: 0.75rem 0 2rem;
}
.lumi .lumi-body .lumi-content .history-list::-webkit-scrollbar {
  width: 0.25rem;
}
.lumi .lumi-body .lumi-content .history-list::-webkit-scrollbar-thumb {
  background: #1E31BF;
  border-radius: 0.25rem;
}
.lumi .lumi-body .lumi-content .history-list::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 0.25rem;
}
.lumi .lumi-body .lumi-content .history-list .history-item {
  width: calc(100% - 1rem);
  display: grid;
  grid-template-columns: 18% 62% 20%;
  gap: 0.5rem;
  border: 1px solid #EBEBEB;
  border-radius: 0.5rem;
  padding: 0.5rem;
  margin-bottom: 0.75rem;
  transition: background 300ms ease-in-out;
}
.lumi .lumi-body .lumi-content .history-list .history-item.support {
  margin-bottom: 1.5rem;
}
.lumi .lumi-body .lumi-content .history-list .history-item.support .history-item-image .history-item-image-icon {
  width: 1.25rem;
  height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lumi .lumi-body .lumi-content .history-list .history-item.support .history-item-image .history-item-image-icon ::ng-deep svg-icon {
  width: 1.25rem;
  height: 1.25rem;
}
.lumi .lumi-body .lumi-content .history-list .history-item.support .history-item-image .history-item-image-icon ::ng-deep svg-icon svg {
  width: 1.25rem;
  height: 1.25rem;
}
.lumi .lumi-body .lumi-content .history-list .history-item:hover {
  background: #F7F8FC;
  cursor: pointer;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-chevron {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-chevron ::ng-deep svg-icon svg {
  height: 1.75rem !important;
  width: 1.75rem !important;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-chevron ::ng-deep svg-icon {
  color: #BCC6FF !important;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-chevron ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #BCC6FF !important;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-chevron ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #BCC6FF !important;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image.project-image {
  padding: 0;
  width: 2.5rem;
  height: 2.5rem;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image.project-image img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image {
  border-radius: 50%;
  border: 1px solid #F5F7FA;
  padding: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.04) 0%,
      rgba(0, 0, 0, 0.01) 99%);
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image .project-initials {
  color: #1E31BF;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image img {
  width: 100%;
  height: 100%;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image ::ng-deep svg-icon svg {
  height: 1.25rem !important;
  width: 1.25rem !important;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image ::ng-deep svg-icon {
  color: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #1E31BF !important;
  stroke: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image ::ng-deep svg-icon svg g {
  color: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image ::ng-deep svg-icon {
  color: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-image ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-content > * {
  display: block;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-content .history-item-title {
  font-family: "PoppinsSemi Bold";
  font-size: 0.8rem;
  color: #1E31BF;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-content .history-item-subtitle {
  font-family: "PoppinsRegular";
  font-size: 0.75rem;
  color: #757575;
}
.lumi .lumi-body .lumi-content .history-list .history-item .history-item-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
}
.lumi .lumi-body .lumi-content .support-message-list {
  width: calc(100% - 3rem);
  margin-top: 1.5rem;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 1.5rem;
  padding-left: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.lumi .lumi-body .lumi-content .support-message-list .lumi-list-loading {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 12rem;
}
.lumi .lumi-body .lumi-content .support-message-list .no-tickets-message {
  text-align: center;
  font-family: "PoppinsRegular";
  font-size: 0.75rem;
}
.lumi .lumi-body .lumi-content .support-message-list::-webkit-scrollbar {
  width: 0.25rem;
}
.lumi .lumi-body .lumi-content .support-message-list::-webkit-scrollbar-thumb {
  background: #1E31BF;
  border-radius: 0.25rem;
}
.lumi .lumi-body .lumi-content .support-message-list::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 0.25rem;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item {
  width: calc(100% - 1rem);
  display: grid;
  grid-template-columns: 18% 62% 20%;
  gap: 0.5rem;
  border: 1px solid #EBEBEB;
  border-radius: 0.5rem;
  padding: 0.5rem;
  margin-bottom: 0.75rem;
  transition: background 300ms ease-in-out;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item:hover {
  background: #F7F8FC;
  cursor: pointer;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-chevron {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-chevron ::ng-deep svg-icon svg {
  height: 1.75rem !important;
  width: 1.75rem !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-chevron ::ng-deep svg-icon {
  color: #BCC6FF !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-chevron ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #BCC6FF !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-chevron ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #BCC6FF !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.project-image {
  padding: 0;
  width: 2.5rem;
  height: 2.5rem;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.project-image img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.pending {
  background:
    linear-gradient(
      to bottom,
      rgba(209, 105, 31, 0.1) 0%,
      rgba(209, 105, 31, 0.01) 99%);
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.pending .support-message-item-icon ::ng-deep svg-icon {
  color: #AC376F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.pending .support-message-item-icon ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #AC376F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.pending .support-message-item-icon ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #AC376F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.pending .support-message-item-icon ::ng-deep svg-icon {
  color: #AC376F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.pending .support-message-item-icon ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #AC376F !important;
  stroke: #AC376F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.pending .support-message-item-icon ::ng-deep svg-icon svg g {
  color: #AC376F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.pending .support-message-item-icon ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #AC376F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.success {
  background:
    linear-gradient(
      to bottom,
      rgba(16, 132, 103, 0.1) 0%,
      rgba(16, 132, 103, 0.01) 99%);
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.success .support-message-item-icon ::ng-deep svg-icon {
  color: #108467 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.success .support-message-item-icon ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #108467 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.success .support-message-item-icon ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #108467 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.success .support-message-item-icon ::ng-deep svg-icon {
  color: #108467 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.success .support-message-item-icon ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #108467 !important;
  stroke: #108467 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.success .support-message-item-icon ::ng-deep svg-icon svg g {
  color: #108467 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.success .support-message-item-icon ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #108467 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.error {
  background:
    linear-gradient(
      to bottom,
      rgba(219, 33, 33, 0.1) 0%,
      rgba(219, 33, 33, 0.01) 99%);
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.error .support-message-item-icon ::ng-deep svg-icon {
  color: #DB2121 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.error .support-message-item-icon ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #DB2121 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.error .support-message-item-icon ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #DB2121 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.error .support-message-item-icon ::ng-deep svg-icon {
  color: #DB2121 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.error .support-message-item-icon ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #DB2121 !important;
  stroke: #DB2121 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.error .support-message-item-icon ::ng-deep svg-icon svg g {
  color: #DB2121 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.error .support-message-item-icon ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #DB2121 !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.disabled {
  opacity: 0.5;
  background:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.04) 0%,
      rgba(0, 0, 0, 0.01) 99%);
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.disabled ::ng-deep svg-icon {
  color: #AAAAAA !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.disabled ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #AAAAAA !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.disabled ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #AAAAAA !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.disabled ::ng-deep svg-icon {
  color: #AAAAAA !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.disabled ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #AAAAAA !important;
  stroke: #AAAAAA !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.disabled ::ng-deep svg-icon svg g {
  color: #AAAAAA !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.disabled ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #AAAAAA !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.warning {
  background:
    linear-gradient(
      to bottom,
      rgba(209, 105, 31, 0.1) 0%,
      rgba(209, 105, 31, 0.01) 99%);
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.warning .support-message-item-icon ::ng-deep svg-icon {
  color: #D1691F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.warning .support-message-item-icon ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #D1691F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.warning .support-message-item-icon ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #D1691F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.warning .support-message-item-icon ::ng-deep svg-icon {
  color: #D1691F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.warning .support-message-item-icon ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #D1691F !important;
  stroke: #D1691F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.warning .support-message-item-icon ::ng-deep svg-icon svg g {
  color: #D1691F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image.warning .support-message-item-icon ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #D1691F !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image .support-message-item-icon {
  width: 1.25rem;
  height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image .support-message-item-icon ::ng-deep svg-icon {
  width: 1.25rem;
  height: 1.25rem;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image .support-message-item-icon ::ng-deep svg-icon svg {
  width: 1.25rem;
  height: 1.25rem;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image {
  border-radius: 50%;
  border: 1px solid #F5F7FA;
  padding: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.04) 0%,
      rgba(0, 0, 0, 0.01) 99%);
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image .project-initials {
  color: #1E31BF;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image img {
  width: 100%;
  height: 100%;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image ::ng-deep svg-icon svg {
  height: 1.25rem !important;
  width: 1.25rem !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image ::ng-deep svg-icon {
  color: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #1E31BF !important;
  stroke: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image ::ng-deep svg-icon svg g {
  color: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image ::ng-deep svg-icon {
  color: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-image ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #1E31BF !important;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-content > * {
  display: block;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-content .support-message-item-title {
  font-family: "PoppinsSemi Bold";
  font-size: 0.8rem;
  color: #1E31BF;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-content .support-message-item-subtitle {
  font-family: "PoppinsRegular";
  font-size: 0.75rem;
  color: #757575;
}
.lumi .lumi-body .lumi-content .support-message-list .support-message-item .support-message-item-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
}
.lumi .lumi-body .lumi-content .lumi-title {
  font-family: "PoppinsSemi Bold";
  font-size: 1.25rem;
  line-height: 1.5rem;
  color: #757575;
}
.lumi .lumi-body .lumi-content .lumi-subtitle {
  font-family: "PoppinsSemi Bold";
  font-size: 1.25rem;
  line-height: 1.5rem;
  color: #1E31BF;
}
.lumi .lumi-body .lumi-content .lumi-buttons {
  display: block;
  margin-top: 1rem;
}
.lumi .lumi-body .lumi-content .lumi-buttons .lumi-button {
  display: block;
  width: 100%;
  background: #FFFFFF;
  border: 0.0625rem solid #EBEBEB;
  border-radius: 0.5rem;
  padding: 1rem;
  text-align: left;
  margin-bottom: 0.5rem;
  transition: background 300ms ease-in-out;
}
.lumi .lumi-body .lumi-content .lumi-buttons .lumi-button:hover {
  background: #F7F8FC;
  cursor: pointer;
}
.lumi .lumi-body .lumi-content .lumi-buttons .lumi-button span {
  font-family: "PoppinsBold";
  font-size: 1rem;
  line-height: 1.25rem;
  color: #1E31BF;
}
.lumi .lumi-body .lumi-content .lumi-buttons .lumi-button p {
  margin-top: 0.25rem;
  font-family: "PoppinsRegular";
  font-size: 0.675rem;
  line-height: 0.9375rem;
  color: #757575;
}
.lumi .lumi-body .lumi-content .lumi-buttons .lumi-button p strong {
  font-family: "PoppinsSemi Bold" !important;
}
.lumi .lumi-body .lumi-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 0.0625rem solid #EBEBEB;
  margin-top: auto;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  flex-shrink: 0;
}
.lumi .lumi-body .lumi-footer .lumi-footer-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
  transition: opacity 300ms ease-in-out;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.lumi .lumi-body .lumi-footer .lumi-footer-item ::ng-deep svg-icon svg {
  height: 1.15rem !important;
  width: 1.25rem !important;
}
.lumi .lumi-body .lumi-footer .lumi-footer-item.history ::ng-deep svg-icon svg {
  height: 1.035rem !important;
  width: 1.125rem !important;
}
.lumi .lumi-body .lumi-footer .lumi-footer-item.active ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon):not([stroke=currentColor]) {
  stroke: transparent !important;
}
.lumi .lumi-body .lumi-footer .lumi-footer-item.active ::ng-deep svg-icon svg g :is(circle, line):not([stroke=currentColor]) {
  stroke: transparent !important;
}
.lumi .lumi-body .lumi-footer .lumi-footer-item.active ::ng-deep svg-icon {
  color: #525252 !important;
}
.lumi .lumi-body .lumi-footer .lumi-footer-item.active ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon, g) {
  color: #525252 !important;
}
.lumi .lumi-body .lumi-footer .lumi-footer-item.active ::ng-deep svg-icon svg :is(path, circle, rect, ellipse, polygon):not([stroke]):not([fill=currentColor]) {
  fill: #525252 !important;
}
.lumi .lumi-body .lumi-footer .lumi-footer-item.active span {
  color: #525252;
}
.lumi .lumi-body .lumi-footer .lumi-footer-item img {
  width: 1.25rem;
  height: 1.25rem;
}
.lumi .lumi-body .lumi-footer .lumi-footer-item span {
  font-family: "PoppinsRegular";
  font-size: 0.6875rem;
  line-height: 1rem;
  color: #757575;
}
/*# sourceMappingURL=lumi.component.css.map */
